import { BreadcrumbsContext } from "./BreadcrumbsContext.js";
import { useCallback, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Breadcrumbs/BreadcrumbsContextProvider.tsx
function BreadcrumbsContextProvider({ children, isCurrentLinkMatcher, onBack, onNavigate }) {
	const [breadcrumbs, setBreadcrumbs] = useState([]);
	const resetBreadcrumbs = useCallback(() => setBreadcrumbs([]), []);
	const appendBreadcrumbs = useCallback((extraBreadcrumbs) => {
		const payload = Array.isArray(extraBreadcrumbs) ? [...breadcrumbs, ...extraBreadcrumbs] : [...breadcrumbs, extraBreadcrumbs];
		setBreadcrumbs(payload);
	}, [breadcrumbs]);
	const ctxValue = useMemo(() => ({
		appendBreadcrumbs,
		breadcrumbs,
		isCurrentLinkMatcher,
		onBack,
		onNavigate,
		resetBreadcrumbs,
		setBreadcrumbs
	}), [
		appendBreadcrumbs,
		breadcrumbs,
		isCurrentLinkMatcher,
		onBack,
		onNavigate,
		resetBreadcrumbs,
		setBreadcrumbs
	]);
	return /* @__PURE__ */ jsx(BreadcrumbsContext.Provider, {
		value: ctxValue,
		children
	});
}
//#endregion
export { BreadcrumbsContextProvider };

//# sourceMappingURL=BreadcrumbsContextProvider.js.map